
import { Component, Vue } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { IOrg } from '@/api/types'

@Component({
  name: 'SelectOrg'
})
export default class extends Vue {


  get orgs(): IOrg[] {
    return UserModule.orgs
  }

  get currentOrgId(): number {
    return UserModule.currentOrg?.id || -1
  }

  public async handleSelectOrg(org: IOrg) {
    try {
      const path = await UserModule.SwitchOrg(org.id)
      this.$message.success('切换组织成功')
      this.$router.push(path)
    } catch (error) {
      console.error('切换组织失败:', error)
      this.$message.error('切换组织失败')
    }
  }

  public async handleLogout() {
    await UserModule.LogOut()
    this.$router.push('/login')
  }
}
